import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Provider from "pubsub-js";
import {scroller, Element} from "react-scroll";
import {TEXT_CHANGED, TEXT_ADDED} from "../../constants/event-types";
import {setTextProperty} from "../../AC/set-text-property";
import Mediator from "../../services/Mediator";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import withSelectionContext from "../../decorators/withSelectionContext";
import TextValue from "./TextValue";
import FontFamily from "./FontFamily";
import FontStyle from "./FontStyle";
import TextAlign from "./TextAlign";
import TextColor from "./TextColor";
import FontSize from "./FontSize";

class TextControl extends Component {
  static propTypes = {
    setTextProperty: PropTypes.func,
    selected: PropTypes.object
  };
  state = {
    text: `Впишите текст`,
    fontFamily: `Helvetica`,
    fontSize: 40,
    fontWeight: `normal`,
    linethrough: false,
    overline: false,
    underline: false,
    shadow: null,
    fontStyle: `normal`,
    stroke: null,
    strokeWidth: 1,
    textAlign: `left`,
    lineHeight: 1.16,
    textBackgroundColor: ``,
    fill: `rgb(0,0,0)`
  };
  onTextChanged = (_, target) => {
    this.setStateFromOText(target);
  };
  setStateFromOText(oText) {
    const {
      text,
      fontFamily,
      fontSize,
      fontWeight,
      linethrough,
      overline,
      underline,
      shadow,
      fontStyle,
      stroke,
      strokeWidth,
      textAlign,
      lineHeight,
      textBackgroundColor,
      fill
    } = oText;
    this.setState({
      text,
      fontFamily,
      fontSize,
      fontWeight,
      linethrough,
      overline,
      underline,
      shadow,
      fontStyle,
      stroke,
      strokeWidth,
      textAlign,
      lineHeight,
      textBackgroundColor,
      fill
    });
  }
  handleChange = (property, val) => (o) => {
    let value =
      (o && o.rgb) ||
      (o && o.target && o.currentTarget.value) ||
      (o && o.target && o.target.value);

    if (o && o.target && o.currentTarget.value === ``) {
      value = o.currentTarget.value;
    }
    if (val || val === false || val === ``) {
      value = val;
    }
    if (value.r || value.r === 0) {
      const {r, g, b, a} = value;
      const rgba = `rgba(${r}, ${g}, ${b}, ${a})`;
      value = rgba;
    }
    this.setState({
      [property]: value
    });
    this.props.setTextProperty(property, value);
  };
  focusTextField = () => {
    const viewHeight = window.innerHeight;
    scroller.scrollTo(`scroll-element`, {
      smooth: true,
      offset: -viewHeight + 150 // Scrolls to element + 50 pixels down the page
    });
  };
  textValueRef = React.createRef();
  componentDidMount() {
    Provider.subscribe(TEXT_ADDED, this.focusTextField);
    Provider.subscribe(TEXT_CHANGED, this.onTextChanged);
  }
  componentDidUpdate(prevProps) {
    const {selected: prevSelected} = prevProps;
    const {selected} = this.props;
    if (
      selected &&
      Mediator.isText(selected) &&
      JSON.stringify(selected) !== JSON.stringify(prevSelected)
    ) {
      this.setStateFromOText(selected);
    }
  }
  componentWillUnmount() {
    Provider.unsubscribe(TEXT_CHANGED, this.onTextChanged);
    Provider.unsubscribe(TEXT_ADDED, this.focusTextField);
  }
  render() {
    const {
      text,
      fontFamily,
      shadow,
      fontSize,
      fontStyle,
      textAlign,
      fill,
      fontWeight,
      underline,
      linethrough
    } = this.state;
    const {selected} = this.props;
    return selected && Mediator.isText(selected) ? (
      <div className="panel-control">
        <div className="panel-control__title">Текст</div>
        <div className="panel-control__content">
          <div className="text-control">
            <div className="text-control__text">
              <Element name="scroll-element" className="element" />
              <TextValue
                current={text}
                inputRef={this.textValueRef}
                handleChange={this.handleChange}
              />
            </div>
            <div className="text-control__group">
              <div className="text-control__font-family">
                <FontFamily
                  current={fontFamily}
                  handleChange={this.handleChange}
                />
              </div>
              <div className="text-control__text-color">
                <TextColor current={fill} handleChange={this.handleChange} />
              </div>
              <div className="text-control__font-size">
                <FontSize current={fontSize} handleChange={this.handleChange} />
              </div>
              <div className="text-control__font-style">
                <FontStyle
                  current={{
                    fontFamily,
                    fontWeight,
                    fontStyle,
                    underline,
                    linethrough,
                    fill,
                    shadow: shadow ? shadow.toString() : ``
                  }}
                  handleChange={this.handleChange}
                />
              </div>
              <div className="text-control__text-align">
                <TextAlign
                  current={textAlign}
                  handleChange={this.handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default connect(null, {setTextProperty})(
  withErrorBoundary(withSelectionContext(TextControl))
);
